import React from "react";
import { TableRow, TableCell } from "@material-ui/core";
import { GolfCourse } from "@material-ui/icons";
import { TournamentPointInfo } from "types/tournament";
import PlayerName from "components/SharedComponents/PlayerName";

export interface TournamentLeaderboardRowClasses {
  cellPos: string;
  cellIcon: string;
  cellName: string;
  cellScore: string;
  rowClickable: string;
}

type LeaderboardPlayer = TournamentPointInfo & {
  guest?: boolean;
  disqualified?: boolean;
  hcp?: number;
};

export type { LeaderboardPlayer };

export interface TournamentLeaderboardRowProps {
  player: LeaderboardPlayer;
  index: number;
  clickable: boolean;
  highlighted: boolean;
  onClick(player: LeaderboardPlayer): void;
  rowClasses: TournamentLeaderboardRowClasses;
}

const TournamentLeaderboardRow: React.FunctionComponent<TournamentLeaderboardRowProps> = ({
  player,
  index,
  clickable,
  highlighted,
  onClick,
  rowClasses,
}) => {
  const ownCell = highlighted ? { backgroundColor: "#cce8cf", boxShadow: "inset 0 0 0 999px #cce8cf" } : undefined;
  return (
    <TableRow
      hover={clickable}
      role={clickable ? "button" : undefined}
      tabIndex={clickable ? 0 : undefined}
      className={clickable ? rowClasses.rowClickable : undefined}
      onKeyDown={
        clickable
          ? (event: React.KeyboardEvent) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                onClick(player);
              }
            }
          : undefined
      }
      onClick={clickable ? () => onClick(player) : undefined}
    >
      <TableCell className={rowClasses.cellPos} component="th" scope="row" style={ownCell}>
        {player.disqualified ? "" : `${index + 1}.`}
      </TableCell>
      <TableCell className={rowClasses.cellIcon} align="center" aria-hidden style={ownCell}>
        {clickable ? <GolfCourse color="primary" fontSize="small" /> : null}
      </TableCell>
      <TableCell className={rowClasses.cellName} style={ownCell}>
        <PlayerName isGuest={player.guest} name={player.name} lastName={player.lastName} />
      </TableCell>
      <TableCell className={rowClasses.cellScore} align="right" style={ownCell}>
        {player.disqualified ? "DQ" : player.points}
      </TableCell>
    </TableRow>
  );
};

export default TournamentLeaderboardRow;
